import { Main_, Main_Plain, Red_ } from 'monica-alexandria';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import i18n from '../../../../../../localization/i18next';
import { ReportHeader } from '../../REPORT.css';

export default function Report_Header(props) {
  
    const { t } = useTranslation();
    const lang = i18n.language ? i18n.language : 'en';

    return (
        <ReportHeader> 
            <div>
                { props.id && <Red_
                            id={"AdSnap_Google_Report_2"} 
                            iconLeft="Delete" 
                            onClick={()=>props.toggleConfirmDlt(true)}
                        /> 
                }
                { props.id && <Main_Plain id={"AdSnap_Google_Report_3"} 
                            iconLeft="Edit" 
                            onClick={() => { window.location.assign(`/${lang}/google/create-report/${props.id}`) }}
                        /> 
                }
            </div>
            <div>
                <Main_Plain 
                    text={t("Upload logo")} 
                    id={"AdSnap_Google_Report_4"} 
                    onClick={() => props.setActiveSlider('upload')} 
                />
                <Main_ 
                    text={t("Export")} 
                    id={"AdSnap_Google_Report_5"} 
                    onClick={() => props.setActiveSlider('export')} 
                />
            </div>
    </ReportHeader>
    );
}
